<template>
  <CCard class="cursor p-0 mx-3">
    <CCardHeader class="p-0 position-relative">
      <image-view
        :src="
          newsDetails.cover_photo
            ? newsDetails.cover_photo
            : '/img/avatars/default-news.png'
        "
        alt="user image"
      ></image-view>
      <div class="status-div">
        <p
          v-if="!!newsDetails.is_published && newsDetails.status === 'PUBLISHED'"
          class="mb-0 published"
        >Published</p>
        <p
          v-if="!newsDetails.is_published && newsDetails.status === 'UNPUBLISHED'"
          class="mb-0 unpublished"
        >Unpublished</p>
        <p
          v-if="(!newsDetails.is_published || !!newsDetails.is_published) && newsDetails.status === 'DRAFT'"
          class="mb-0 drafts"
        >Draft</p>
      </div>
    </CCardHeader>
    <CCardBody class="py-2">
      <h5 class="title text-capitalize">
        <b>{{ newsDetails.title }}</b>
      </h5>
      <div class="d-just-space mb-2">
        <p class="mb-0">
          By DocSmart
          <br />
          <b>{{ getDate(newsDetails.updated_at) }}</b>
        </p>
        <div class="d-flex">
          <div class="blog-count mr-2 d-align">
            <image-view :src="'/img/avatars/visibility.png'" class="mr-1"></image-view>
            <p class="mb-0">{{ newsDetails.views_count }}</p>
          </div>
          <div class="blog-count mr-2 d-align">
            <image-view :src="'/img/avatars/speech-bubble.png'" class="mr-1"></image-view>
            <p class="mb-0">{{ commentNumber }}</p>
          </div>
          <div class="blog-count d-align">
            <image-view :src="'/img/avatars/like.png'" class="mr-1"></image-view>
            <p class="mb-0">{{newsDetails.likes.length}}</p>
          </div>
        </div>
      </div>
      <p v-html="newsDetails.description" class="text mb-2"></p>
      <div
        class="text-capitalize m-0 d-flex justify-content-space-bet align-items-center pt-2 pb-2"
      >
        <p
          v-if="permissions.includes('CAN_EDIT_NEWS_LISTING')"
          @click="getEditDetails()"
          class="mb-0"
        >
          <image-view
            :src="'/img/avatars/edit-blog.png'"
            class="mr-2 editblogImage font-weight-bold"
          ></image-view>
          <span class="edit-text">EDIT NEWS</span>
        </p>

        <v-btn
          v-if="newsDetails.status !== 'DRAFT'"
          @click="getViewDetails()"
          text
          x-large
          color="success"
        >READ MORE</v-btn>
      </div>
    </CCardBody>
    <CCardFooter class="flex-end">
      <!-- DELETE BUTTON -->
      <span
        v-if="
          (newsDetails.is_published === true &&
            newsDetails.status === 'PUBLISHED') ||
            (newsDetails.is_published === false &&
              newsDetails.status === 'UNPUBLISHED')
        "
      >
        <v-btn
          v-if="permissions.includes('CAN_DELETE_NEWS_LISTING')"
          color="error"
          class="mr-4"
          :disabled="
            newsDetails.is_published && newsDetails.status === 'PUBLISHED'
          "
          @click="openSwal('delete')"
        >Delete</v-btn>
      </span>

      <!-- DISCARD BUTTON -->
      <span v-else>
        <v-btn
          v-if="permissions.includes('CAN_DISCARD_NEWS_LISTING')"
          color="error"
          class="mr-4"
          @click="openSwal('discard')"
        >Discard</v-btn>
      </span>

      <!-- UNPUBLISH BUTTON -->
      <span v-if="!!newsDetails.is_published && newsDetails.status === 'PUBLISHED'">
        <v-btn
          v-if="permissions.includes('CAN_UNPUBLISH_NEWS_LISTING')"
          color="success"
          @click="openSwal('unpublish')"
        >Unpublish</v-btn>
      </span>

      <!-- PUBLISH BUTTON -->
      <span v-else>
        <v-btn
          v-if="permissions.includes('CAN_PUBLISH_NEWS_LISTING')"
          color="success"
          @click="openSwal('publish')"
        >Publish</v-btn>
      </span>
      <!-- <v-btn color="success" >Unpublish</v-btn> -->
    </CCardFooter>
  </CCard>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
import { mapGetters } from "vuex";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
const Image = () => import("@/components/image.vue");
export default {
  props: ["newsDetails"],
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  components: {
    "image-view": Image
  },
  data() {
    return {
      dayJS,
      commentDetails: [],
      commentNumber: ""
    };
  },
  mounted() {
    this.getComments();
  },
  methods: {
    getComments() {
      let url = `${config.BASE_URL}api/v2/news/comment/${this.newsDetails._id}`;
      let params = {
        page: this.currentPage,
        records_per_page: 3
      };
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.commentNumber = response.body.data.count;
          if (response.body.data.list) {
            this.commentDetails = response.body.data.list;
          } else {
            this.commentDetails = {};
          }
        }
      });
    },
    getEditDetails() {
      this.$router.push({
        name: "Create News",
        params: { slug: this.newsDetails.slug, id: this.newsDetails._id }
      });
    },

    getViewDetails() {
      this.$router.push(`/news/${this.newsDetails.slug}`);
    },

    getDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },

    openSwal(status) {
      let newsStatus = status.charAt(0).toUpperCase() + status.slice(1);
      Swal.fire({
        title: `Are you sure you want to ${newsStatus} this news`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          if (status === "delete") {
            this.deleteNews(status);
          } else if (status === "discard") {
            this.deleteNews(status);
          } else if (status === "publish") {
            this.updateNews(status);
          } else {
            this.updateNews(status);
          }
        }
      });
    },

    updateNews(status) {
      let newsStatus = status.charAt(0).toUpperCase() + status.slice(1);
      let obj;
      if (status === "publish" || status === "unpublish") {
        obj = {
          title: this.newsDetails.title,
          cover_photo: this.newsDetails.cover_photo,
          // short_description: this.newsDetails.short_description,
          description: this.newsDetails.description,
          category: this.newsDetails.category,
          tags: this.newsDetails.tags,
          status: status
        };
      } else {
        obj = {
          is_deleted: true
        };
      }
      let url = `${config.BASE_URL}api/v2/admin/news/${this.newsDetails._id}`;
      this.$http.put(url, obj).then(response => {
        if (!!response.ok) {
          Swal.fire({
            title: `News ${newsStatus}ed Successfully`,
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok"
          }).then(result => {
            if (result.isConfirmed) {
              this.$emit("refreshList");
            }
          });
        }
      });
    },

    deleteNews(status) {
      let url = `${config.BASE_URL}api/v2/admin/news/${this.newsDetails._id}`;
      this.$http.delete(url, {}).then(response => {
        if (!!response.ok) {
          Swal.fire({
            title:
              status === "delete"
                ? "News Deleted Successfully"
                : "News Discarded Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok"
          }).then(result => {
            if (result.isConfirmed) {
              this.$emit("refreshList");
            }
          });
        }
      });
    }
  }
};
</script>